var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.875a6.879 6.879 0 01-8.157 6.755l-.943 1.055a.937.937 0 01-.7.315H8.75v1.563a.937.937 0 01-.937.938H6.25v1.563a.937.937 0 01-.937.936H.938A.937.937 0 010 19.063v-3.05a.938.938 0 01.275-.663l6.32-6.32A6.876 6.876 0 1120 6.875zM13.125 5A1.875 1.875 0 1015 3.125 1.875 1.875 0 0013.125 5z",
    fill: "#797979"
  })));
}
export default SvgPassword;